import OneLifeApp from './components/OneLifeApp';

export default function App() {
  return <OneLifeApp />;
}
